export enum REVIEW_TABS {
  HOME = 'HOME',
  REVIEWS = 'REVIEWS',
  METRICS = 'METRICS',
  KEYWORDS = 'KEYWORDS',
  GOOGLE = 'GOOGLE REVIEWS',
  YELP = 'YELP REVIEWS',
  OTHER_REVIEWS = 'OTHER REVIEWS'
}
